import type { BlobFailureReason } from '@cli-types/next-adapter/vercel.js'

export function blobFailureMessage(reason?: BlobFailureReason): string {
  switch (reason) {
    case 'env-pull-empty':
      return 'Created a Blob store, but no BLOB_READ_WRITE_TOKEN came back from Vercel.'
    case 'timeout':
      return 'Vercel Blob provisioning timed out.'
    default:
      return 'Vercel Blob provisioning did not complete.'
  }
}
